import { ReactNode } from 'react'
import { Cell, Spacer, Text } from '@vinted/web-ui'

type Props = {
  title: ReactNode
  subtitle: ReactNode
  styling?: React.ComponentProps<typeof Cell>['styling']
}

const Heading = ({ title, subtitle, styling = 'wide' }: Props) => {
  return (
    <Cell styling={styling}>
      <Text as="h1" type="heading">
        {title}
      </Text>
      <Spacer size="regular" />
      <Text as="span" html>
        {subtitle}
      </Text>
    </Cell>
  )
}

export default Heading
